import { useSelector } from 'react-redux';
import { getRemainingDaysToExpiration } from 'domains/Auth/authSlice/authSelectors';

function useGetStoreRemainingDaysToExpiration() {
  return useSelector(getRemainingDaysToExpiration);
}

export default useGetStoreRemainingDaysToExpiration;
